<script lang="ts">
  import { push } from 'svelte-spa-router';
  import { loginUser } from '../../../../components/auth/LoginUser';
  import NotesReturnOfTerminalAdapterParts from '../parts/NotesReturnOfTerminalAdapterParts.svelte';
  import NotesTerminateIenodenwaParts from '../parts/NotesTerminateIenodenwaParts.svelte';
  import RepositoryFactory, { SUB_CONTRACT_HIKARI01_TEL } from '../../../../repositories/RepositoryFactory';
  import type { IIenodenwaItem, ITerminateIenodenwaItem, TConfirmedBgColor } from './types';
  import { format } from 'date-fns';
  import { ja } from 'date-fns/locale';

  export let ienodenwaItem: IIenodenwaItem;

  let pageStatus: 'TOP' | 'CONFIRM' | 'COMPLETE' = 'TOP';

  const terminateIenodenwaItem: ITerminateIenodenwaItem = {
    contractName: ienodenwaItem.contractName,
    telNo: ienodenwaItem.telNo,
    terminateDate: format(new Date(), 'yyyy/MM/dd', { locale: ja })
  };
  let confirmedBgColor: TConfirmedBgColor = 'bg-yellow-100';
  let agreementFlg: boolean = false;

  const onChangeCheckbox = (): void => {
    confirmedBgColor = agreementFlg ? 'bg-sky-100' : 'bg-yellow-100';
  };

  $: isAgreementChecked = () => {
    return agreementFlg;
  };

  const handleTransitionConfirm = (): void => {
    pageStatus = 'CONFIRM';
  };

  const handleTransitionComplete = (): void => {
    const repository = RepositoryFactory[SUB_CONTRACT_HIKARI01_TEL];
    repository
      .terminateIenodenwa()
      .then((response) => {
        pageStatus = 'COMPLETE';
      })
      .catch((error) => errorProcess(error));
  };

  const errorProcess = (error: any) => {
    if (error.response.status === 403) {
      alert('セッションが切れました。再度ログインしてください。');
      loginUser.logout();
      push('/login');
    } else {
      alert('エラーが発生しました。');
    }
  };
</script>

{#if pageStatus === 'TOP'}<!-- トップ画面 -->
  <div class="shadow rounded bg-white border-t-2 border-green-400">
    <div class="m-10">
      <div class="inline-flex justify-items-center items-center min-w-full">
        <div class="mb:font-sm w-full">
          <p>以下の内容でお手続きさせていただきます。内容を確認いただき、「手続きへ」を押下ください</p>
          <ul class="list-disc mt-4 ml-4">
            <li>
              <p>解約する電話契約：{terminateIenodenwaItem.contractName}</p>
            </li>
            <li>
              <p>電話番号：{terminateIenodenwaItem.telNo}</p>
            </li>
            <li>
              <p>解約日：{terminateIenodenwaItem.terminateDate}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 注意事項 -->
    <div class="mb-4">
      <NotesTerminateIenodenwaParts />
    </div>

    <!-- ターミナルアダプタの返却先 -->
    <div class="mb-4">
      <NotesReturnOfTerminalAdapterParts />
    </div>

    <div class="flex flex-col justify-items-center items-center p-2">
      <div class="flex items-center px-4 rounded border border-transparent w-11/12 {confirmedBgColor}">
        <input
          id="agreementFlg"
          type="checkbox"
          class="w-4 h-4 text-red-600"
          bind:checked={agreementFlg}
          on:change={onChangeCheckbox}
        />
        <label for="agreementFlg" class="py-4 ml-2 w-full text-sm font-medium text-red-700"
          >電話番号の取り扱い、電話アダプタの返却について同意の上、解約します</label
        >
      </div>
    </div>

    <div class="flex flex-col justify-items-center items-center">
      <div class="flex-1 m-5 flex flex-col md:flex-row justify-items-center items-center">
        <button class="button-primary md:ml-5 mb-5" on:click={handleTransitionConfirm} disabled={!isAgreementChecked()}>
          手続きへ
        </button>
      </div>
    </div>
  </div>
{:else if pageStatus === 'CONFIRM'}<!-- いえのでんわ解約 確認 -->
  <div class="shadow rounded bg-white border-t-2 border-green-400">
    <div class="m-10">
      <div class="inline-flex justify-items-center items-center min-w-full">
        <div class="mb:font-sm w-full">
          <p>以下の内容で電話契約の解約手続きを進めます。問題なければ実行ボタンを押下ください。</p>
          <ul class="list-disc mt-4 ml-4">
            <li>
              <p>解約する電話契約：{terminateIenodenwaItem.contractName}</p>
            </li>
            <li>
              <p>電話番号：{terminateIenodenwaItem.telNo}</p>
            </li>
            <li>
              <p>解約日：{terminateIenodenwaItem.terminateDate}</p>
            </li>
            <li>
              <p>電話番号の取り扱い、電話アダプタの返却についての同意事項：チェック済</p>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="flex flex-col justify-items-center items-center">
      <div class="flex-1 m-5 flex flex-col md:flex-row justify-items-center items-center">
        <button class="button-primary md:ml-5 mb-5" on:click={handleTransitionComplete}> 実行 </button>
      </div>
    </div>
  </div>
{:else if pageStatus === 'COMPLETE'}<!-- いえのでんわ解約 完了 -->
  <div class="shadow rounded bg-white border-t-2 border-green-400">
    <div class="m-10">
      <div class="inline-flex justify-items-center items-center min-w-full mb-20">
        <div class="mb:font-sm w-full">
          <ul class="list-none mt-4">
            <li>
              <p>いえのでんわの解約依頼を受け付けました</p>
            </li>
            <li>
              <p>なお、いえのでんわの解約手続きが完了するまでに数日のお時間をいただく場合がある点ご了承ください。</p>
            </li>
            <li class="mt-6">
              <p>お手続きについてご不明な点がございましたら、以下からご連絡いただくようお願いいたします。</p>
            </li>
            <li>
              <p>URL：https://bb01.unext.co.jp/contact</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
{/if}

<style lang="postcss">
  p:not([class]) {
    @apply tracking-normal mb-1;
  }
  .button-primary {
    @apply bg-green-400 rounded hover:bg-green-500 text-sm font-semibold text-white focus:outline-none px-10 py-2;
  }
  .button-primary:disabled {
    @apply opacity-30 cursor-default;
  }
</style>
